import { BackToTop } from '@/components/BackToTop';
import { Footer } from '@/components/Footer';
import { Header } from '@/components/Header';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface PageLayoutProps {
  children: React.ReactNode;
}

export function PageLayout({ children }: PageLayoutProps) {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col">
      <Header showSearchInHeader={false} />
      <main className="flex-1 bg-white">
        <div className="container mx-auto py-8">
          <Button
            variant="ghost"
            onClick={() => navigate(-1)}
            className="mb-8 hover:underline transition-colors"
          >
            <ArrowLeft className="mr-2 h-4 w-4" />
            Back
          </Button>
          {children}
        </div>
      </main>
      <BackToTop />
      <Footer />
    </div>
  );
}
